import React from 'react'
import PropTypes from 'prop-types'
import CustomersItem from "./CustomersItem"

CustomersBody.propTypes = {
    error: PropTypes.string,
    listCustomers: PropTypes.array
}

function CustomersBody(props) {
    const {error, listCustomers} = props

    return (
        <tbody className="CustomersBody">
        {
            !!listCustomers && listCustomers.length > 0 ? listCustomers.map((item, index) => (
                <CustomersItem {...props} key={index} index={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={9}>Không có bản ghi nào.</td>
            </tr>
        }

        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={9}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default CustomersBody
